import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

import { IFileShareListItem } from './types';

export function useListFileShares({ corporationId }: { corporationId: number }): {
  data: { shares: IFileShareListItem[] } | undefined;
  error: unknown;
  mutate: KeyedMutator<unknown>;
} {
  const { data, error, mutate } = useSWR<{ shares: IFileShareListItem[] }>(
    `file-shares?corporationId=${corporationId}`,
    SWRFetcher({ method: 'GET' })
  );

  return { data, error, mutate };
}
